import { Component, OnInit } from '@angular/core';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { Createproject } from 'src/app/model/createproject.model';
import { Vendorregistration } from 'src/app/model/vendorregistration.model';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.css']
})
export class VendorComponent implements OnInit {
  data : Vendordata;
  evaluationDataAny:any;
  vendreg:Vendorregistration;

  constructor(private userService : UserService,private toastr: ToastrService,private router: Router,private evaluationService : EvaluationService, private dataSharingService: DataSharingService) { }

  ngOnInit() {
    this.vendreg = new Vendorregistration();
    // this.evaluationService.getEvaluatedVendors().subscribe(
    //   (data) => {
    //     this.evaluationDataAny = data;
    //     this.data = this.evaluationDataAny;
    //     console.log(this.data);
    //   }
    // )
  }

  OnSubmit(form:NgForm)
  {
    console.log(form.value);
    this.userService.addVendorData(form.value)
    .subscribe((data : any) => {
      if(data != null && data != undefined)
      {
        this.toastr.success("Vendor Created Successfully",'',{ progressBar: true });
        this.resetForm(form);
      }
    });

  }

  resetForm(form)
  {
    if(form != null){
      form.reset();
    }
  }

}
